import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./error-pages.css";

const ERROR_CONFIG = {
  401: {
    eyebrowKey: "errors.401.eyebrow",
    titleKey: "errors.401.title",
    subtitleKey: "errors.401.subtitle",
    descriptionKey: "errors.401.description",
    metaKey: "errors.401.meta",
    primaryKey: "errors.401.primary",
    secondaryKey: "errors.401.secondary",
  },
  403: {
    eyebrowKey: "errors.403.eyebrow",
    titleKey: "errors.403.title",
    subtitleKey: "errors.403.subtitle",
    descriptionKey: "errors.403.description",
    metaKey: "errors.403.meta",
    primaryKey: "errors.403.primary",
    secondaryKey: "errors.403.secondary",
  },
  404: {
    eyebrowKey: "errors.404.eyebrow",
    titleKey: "errors.404.title",
    subtitleKey: "errors.404.subtitle",
    descriptionKey: "errors.404.description",
    metaKey: "errors.404.meta",
    primaryKey: "errors.404.primary",
    secondaryKey: "errors.404.secondary",
  },
  500: {
    eyebrowKey: "errors.500.eyebrow",
    titleKey: "errors.500.title",
    subtitleKey: "errors.500.subtitle",
    descriptionKey: "errors.500.description",
    metaKey: "errors.500.meta",
    primaryKey: "errors.500.primary",
    secondaryKey: "errors.500.secondary",
  },
};

export default function ErrorPage({ code = 404, authenticated = false }) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const config = ERROR_CONFIG[code] || ERROR_CONFIG[404];

  const goPrimary = () => {
    if (code === 401) {
      navigate("/login");
      return;
    }

    if (authenticated) {
      navigate("/dashboard");
      return;
    }

    navigate("/");
  };

  const goSecondary = () => {
    if (code === 403 || code === 404) {
      if (authenticated) {
        navigate("/my-collection");
      } else {
        navigate("/login");
      }
      return;
    }

    if (code === 500) {
      window.location.reload();
      return;
    }

    navigate("/");
  };

  return (
    <main className="artkiv-error-page" aria-labelledby="artkiv-error-title">
      <div className="artkiv-error-shell">
        <section className="artkiv-error-copy">
          <div className="artkiv-error-brand">ARTKIV</div>

          <div className="artkiv-error-cartel">
            <p className="artkiv-error-eyebrow">{t(config.eyebrowKey)}</p>
            <h1 id="artkiv-error-title">{t(config.titleKey)}</h1>
            <p className="artkiv-error-subtitle">{t(config.subtitleKey)}</p>
            <p className="artkiv-error-description">{t(config.descriptionKey)}</p>
            <p className="artkiv-error-meta">{t(config.metaKey)}</p>
          </div>

          <div className="artkiv-error-actions">
            <button type="button" className="artkiv-error-primary" onClick={goPrimary}>
              {t(config.primaryKey)}
            </button>
            <button type="button" className="artkiv-error-secondary" onClick={goSecondary}>
              {t(config.secondaryKey)}
            </button>
          </div>
        </section>

        <section className={`artkiv-error-visual artkiv-error-visual--${code}`} aria-hidden="true">
          <div className="artkiv-error-wall-mark artkiv-error-wall-mark--tl" />
          <div className="artkiv-error-wall-mark artkiv-error-wall-mark--tr" />
          <div className="artkiv-error-wall-mark artkiv-error-wall-mark--bl" />
          <div className="artkiv-error-wall-mark artkiv-error-wall-mark--br" />
          <div className="artkiv-error-frame">
            <span>{code}</span>
          </div>
        </section>
      </div>
    </main>
  );
}
